<template>
	<div class="full">
		<vxe-grid ref="orderdetail" v-if="list_gridOptions" v-bind="list_gridOptions"
			@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	export default {
		mixins: [listMixins],
		props: {
			currentRow: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				loading: false,
				list_autorender: false,
				list_footerField: [{
					field: 'size',
					toFixed: 0
				}, {
					field: 'sum',
					toFixed: 2
				}],
			}
		},
		watch: {
			currentRow() {
				this.$refs.orderdetail.commitProxy('query')
			},
		},
		computed: {

		},
		created() {

		},
		mounted() {
			this.init()

		},
		methods: {
			init() {
				let list_columns = [{
					field: 'skuCode',
					title: '商品编码',
				}, {
					field: 'goodsName',
					title: '商品名称',
				}, {
					field: 'skuName',
					title: '规格'
				}, {
					field: 'size',
					title: '数量'
				}, {
					field: 'price',
					title: '单价'
				}, {
					field: 'unitName',
					title: '单位'
				}, {
					field: 'sum',
					title: '小计'
				}]
				let list_toolbarButton = []
				this.columns = list_columns
				this.toolbarButton = list_toolbarButton
				this.list_init()
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = this.columns
				gridOptions.toolbarConfig.buttons = this.toolbarButton
				gridOptions.formConfig = false
				gridOptions.scrollY = {
					enabled: false
				}
			},
			list() {
				return new Promise((resolve) => {
					this.$api.purchasestockbill.getDetail({
						stockCode: this.currentRow.stockCode
					}).then((res) => {
						resolve({
							list: res
						})
					})
				})
			},
		},
		components: {
			
		}
	}
</script>